import { Link } from "react-router-dom";
import "./chalet.css";



export default function ChaletCard({
  id,
  eventId,
  img,
  imgMobile,
  name,
  pricing,
  monthlyPrices,
  hasDiscount,
  discountPercent,
  rooms,
  halls,
  bathrooms,
  pool,
  isPrivate,
  vip,
  notes,
  showNotes = false,
  eventMode = false,
  priority = false,
}) {

  const monthKey = new Intl.DateTimeFormat("en-CA", {
    year: "numeric",
    month: "2-digit",
  }).format(new Date());

  const monthEntry = monthlyPrices?.[monthKey];

  const pricingOverride =
    typeof monthEntry === "object" && monthEntry
      ? monthEntry
      : {};

  const effectivePricing = {
    fullWeek: pricingOverride.fullWeek || pricing?.fullWeek,
    halfWeek: pricingOverride.halfWeek || pricing?.halfWeek,
    weekend: pricingOverride.weekend || pricing?.weekend,
  };

  const percent = hasDiscount ? Number(discountPercent || 0) : 0;

  const validDiscount =
    Number.isFinite(percent) && percent > 0;

  const sanitizePriceNumber = (value) => {

    if (value === null || value === undefined || value === "")
      return null;

    const numeric = Number(
      String(value).replace(/[^0-9.]/g, "")
    );

    return Number.isFinite(numeric)
      ? numeric
      : null;
  };

  const formatPrice = (value) =>
    new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 0
    }).format(value);

  const buildPriceInfo = (value) => {

    if (value === null || value === undefined || value === "") {

      return { hasValue: false };

    }

    const numeric = sanitizePriceNumber(value);

    if (numeric === null) {

      return {
        hasValue: true,
        originalText: String(value),
        discountedText: "",
        isDiscounted: false,
      };

    }

    const originalText = formatPrice(numeric);

    if (!validDiscount) {

      return {
        hasValue: true,
        originalText,
        discountedText: "",
        isDiscounted: false,
      };

    }

    const discountedNumber =
      Math.round(
        numeric * (1 - percent / 100) * 100
      ) / 100;

    return {

      hasValue: true,
      originalText,
      discountedText:
        formatPrice(discountedNumber),
      isDiscounted: true,

    };

  };

  const pricingInfo = {

    fullWeek:
      buildPriceInfo(effectivePricing.fullWeek),

    halfWeek:
      buildPriceInfo(effectivePricing.halfWeek),

    weekend:
      buildPriceInfo(effectivePricing.weekend),

  };

  const showPricing = Boolean(

    pricingInfo.fullWeek.hasValue ||
    pricingInfo.halfWeek.hasValue ||
    pricingInfo.weekend.hasValue

  );


  /*
  ============================
  السعر الخاص بالمناسبة فقط
  ============================
  */

  const eventPrice =
    pricingInfo.fullWeek ||
    pricingInfo.halfWeek ||
    pricingInfo.weekend;


  return (

    <div className="chalet-card">

      <img
        src={imgMobile || img}
        alt={name}
        width="800"
        height="600"
        loading={priority ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : "low"}
        decoding="async"
      />

      <div className="chalet-body">


        {/* ===== السعر ===== */}

        {showPricing && (

          eventMode ? (

            <div className="card-pricing">

             <div className="card-price-item full-width center">

  <div className="card-price-value event-price">

    <span className="fire-icon">💎</span>

    <span>
      {eventPrice.originalText} د.ك
    </span>

  </div>

</div>

            </div>

          ) : (

            <div className="card-pricing">

              {pricingInfo.fullWeek.hasValue && (

                <div className="card-price-item">

                  <div className={`card-price-value ${pricingInfo.fullWeek.isDiscounted ? "has-discount" : ""}`}>

                    {pricingInfo.fullWeek.isDiscounted ? (

                      <>

                        <span className="card-price-old">
                          {pricingInfo.fullWeek.originalText} د.ك
                        </span>

                        <span className="card-price-new">
                          {pricingInfo.fullWeek.discountedText} د.ك
                        </span>

                      </>

                    ) : (

                      <span>
                        {pricingInfo.fullWeek.originalText} د.ك
                      </span>

                    )}

                  </div>

                  <div className="card-price-label">
                    أسبوع كامل
                  </div>

                </div>

              )}


              {pricingInfo.halfWeek.hasValue && (

                <div className="card-price-item">

                  <div className={`card-price-value ${pricingInfo.halfWeek.isDiscounted ? "has-discount" : ""}`}>

                    {pricingInfo.halfWeek.isDiscounted ? (

                      <>

                        <span className="card-price-old">
                          {pricingInfo.halfWeek.originalText} د.ك
                        </span>

                        <span className="card-price-new">
                          {pricingInfo.halfWeek.discountedText} د.ك
                        </span>

                      </>

                    ) : (

                      <span>
                        {pricingInfo.halfWeek.originalText} د.ك
                      </span>

                    )}

                  </div>

                  <div className="card-price-label">
                    نصف أسبوع
                  </div>

                </div>

              )}


              {pricingInfo.weekend.hasValue && (

                <div className="card-price-item">

                  <div className={`card-price-value ${pricingInfo.weekend.isDiscounted ? "has-discount" : ""}`}>

                    {pricingInfo.weekend.isDiscounted ? (

                      <>

                        <span className="card-price-old">
                          {pricingInfo.weekend.originalText} د.ك
                        </span>

                        <span className="card-price-new">
                          {pricingInfo.weekend.discountedText} د.ك
                        </span>

                      </>

                    ) : (

                      <span>
                        {pricingInfo.weekend.originalText} د.ك
                      </span>

                    )}

                  </div>

                  <div className="card-price-label">
                    ويكند
                  </div>

                </div>

              )}

            </div>

          )

        )}



        {/* ===== الاسم ===== */}

        <h4 className="chalet-title">

          {name}

          {vip &&

            <span className="vip-inline">

              VIP

            </span>

          }

        </h4>


        {/* ===== الخصائص ===== */}

        <div className="icons">

          <div className="icon-item">
            🛏 عدد الغرف ({rooms ?? 0})
          </div>

          <div className="icon-item">
            🛋 عدد الصالات ({halls ?? 0})
          </div>

          <div className="icon-item">
            🏊 {pool ? "مسبح خارجي" : "بدون مسبح"}
          </div>

          <div className="icon-item">
            🏠 {isPrivate ? "شاليه خاص" : "شاليه مشترك"}
          </div>

          <div className="icon-item">
            🛁 عدد الحمامات ({bathrooms ?? 0})
          </div>

        </div>


        {showNotes && notes && (

          <ul className="notes-list">

            {notes.map((note, idx) => (

              <li key={idx}>{note}</li>

            ))}

          </ul>

        )}


      <Link
  className="details-btn"
  to={`/chalets/${id}${eventMode && eventId ? `?event=${eventId}` : ""}`}
>
  التفاصيل والتواريخ المتوفرة
</Link>


      </div>

    </div>

  );

}
